import type { AnnotationsTooltipProps } from '../../../core/components/annotations/components/tooltip/types/annotations-tooltip-props.js';

/** TimeseriesChart Annotations.Tooltip subcomponent props */
export const AnnotationsTooltip = (props: AnnotationsTooltipProps) => null;

AnnotationsTooltip['displayName'] = 'TimeseriesAnnotations.Tooltip';
